import { useEffect, useState } from "react";

export default function About() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section id="about" className="min-h-screen bg-gradient-to-br from-black via-gray-900 to-black text-white relative overflow-hidden py-20">
      {/* Animated background elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute -top-40 -right-40 w-80 h-80 bg-blue-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute -bottom-40 -left-40 w-80 h-80 bg-purple-500/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-gradient-to-r from-blue-500/5 to-purple-500/5 rounded-full blur-3xl animate-pulse delay-500"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header Section */}
        <div className={`text-center mb-16 transition-all duration-1000 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-6">
            About{" "}
            <span className="bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 bg-clip-text text-transparent">
              Me
            </span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Passionate MERN Stack Developer with expertise in building modern, scalable web applications
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-stretch">
          
          {/* Left: Personal Skills */}
          <div className={`space-y-8 transition-all duration-1000 delay-200 h-full flex flex-col justify-center` +
            (isVisible ? ' opacity-100 translate-y-0' : ' opacity-0 translate-y-10')
          }>
            <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 h-full flex flex-col justify-center">
              <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Personal Skills
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {["Effective Communication","Adaptability","Leadership","Creativity","Time Management","Interpersonal Skills","Problem Solving"].map((skill, index) => (
                  <div key={index} className="flex items-center space-x-3 group">
                    <div className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full group-hover:scale-150 transition-transform duration-300"></div>
                    <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                      {skill}
                    </span>
                  </div>
                ))}
              </div>
            </div>
            <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 h-full flex flex-col justify-center">
              <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Coding Skills
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {["React-JS, Next-JS","Redux","Vue-JS","Vuex","Express-JS","Node- JS","JavaScript, JQuery", "WordPress", "SCSS", "Tailwind, Bootstrap, CSS", "HTML", "GIT Version Control", "Front-End Optimization", "MongoDB", "PostegreSQL"].map((skill, index) => (
                  <div key={index} className="flex items-center space-x-3 group">
                    <div className="w-2 h-2 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full group-hover:scale-150 transition-transform duration-300"></div>
                    <span className="text-gray-300 group-hover:text-white transition-colors duration-300">
                      {skill}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* Right: Experience */}
          <div className={`space-y-8 transition-all duration-1000 delay-400 h-full flex flex-col justify-center` +
            (isVisible ? ' opacity-100 translate-y-0' : ' opacity-0 translate-y-10')
          }>
            <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300 h-full flex flex-col justify-center">
              <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Professional Experience
              </h3>
              
              {/* Current Role */}
               <div className="mb-8">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div className="flex-1">
                    <h4 className="text-xl font-semibold text-white mb-2">
                      Danam Infotech Pvt Ltd
                    </h4>
                    <p className="text-blue-400 font-medium mb-3">August 2025 - Present</p>
                    <ul className="space-y-3 text-gray-300">
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Full-stack Developer (Next.js, PostgreSQL, Prisma) with hands-on experience building Hotel ERP systems, procurement modules, and advanced inventory valuation logic.</span>
                      </li>                      
                    </ul>
                  </div>
                </div>
              </div>
              <div className="mb-8">
                <div className="flex items-start space-x-4 mb-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div className="flex-1">
                    <h4 className="text-xl font-semibold text-white mb-2">
                      ITFlex Solution India Pvt Ltd
                    </h4>
                    <p className="text-blue-400 font-medium mb-3">August 2023 - July 2025</p>
                    <ul className="space-y-3 text-gray-300">
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Developed and maintained scalable full-stack applications using MongoDB, Express.js, React.js, and Node.js</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Led end-to-end implementation of RESTful APIs and responsive user interfaces across web and mobile platforms</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Optimized performance and security of applications while collaborating with cross-functional teams in agile environments</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Improved front-end performance by leveraging lazy loading, WebP image formats, code splitting, and reducing render-blocking resources</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="grid grid-cols-1  gap-12 lg:gap-16 mt-12 lg:mt-16">
        <div className={`space-y-8 transition-all duration-1000 delay-400 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}>
            <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <div>
                <div className="flex items-start space-x-4">
                  <div className="w-3 h-3 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full mt-2 flex-shrink-0"></div>
                  <div className="flex-1">
                  <h4 className="text-xl font-semibold text-white mb-2">
                      Digi Daily Training Center
                    </h4>
                    <p className="text-blue-400 font-medium mb-3">2021 -2023</p>                 
                    <ul className="space-y-3 text-gray-300">
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Conducted structured training sessions on HTML5, CSS3, JavaScript (ES6+), and React.js with Redux for students and working professionals.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Designed and delivered comprehensive frontend development curriculum, including theory, practical exercises, and real-world projects.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Provided hands-on training using live coding sessions, mini projects, and assignments to reinforce learning.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Explained core concepts like DOM manipulation, CSS Flexbox/Grid, responsive design, and JavaScript event handling.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Taught students how to build single-page applications (SPAs) using React.js and manage state with Redux.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Guided learners on integrating REST APIs and implementing React Hooks such as useState, useEffect, and useReducer.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Evaluated student performance through code reviews, assessments, and project demos.</span>
                      </li>
                      <li className="flex items-start space-x-3">
                        <span className="text-blue-400 mt-1">•</span>
                        <span>Introduced modern tools and workflows such as Git/GitHub, VS Code, Browser DevTools, and NPM/Yarn.</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
            </div>
        </div> */}

        {/* Additional Info Section */}
        <div className={`mt-16 transition-all duration-1000 delay-600 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
        }`}>
          <div className="bg-white/5 backdrop-blur-md rounded-2xl p-8 border border-white/10 hover:border-white/20 transition-all duration-300">
            <h3 className="text-2xl font-bold mb-6 bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent text-center">
              What I Bring to the Table
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-blue-500/10 to-purple-500/10 border border-blue-500/20">
                <div className="w-16 h-16 bg-gradient-to-r from-blue-400 to-purple-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.75 17L9 20l-1 1h8l-1-1-.75-3M3 13h18M5 17h14a2 2 0 002-2V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-white mb-2">Full Stack Development</h4>
                <p className="text-gray-400">End-to-end web application development with modern technologies</p>
              </div>
              
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-purple-500/10 to-pink-500/10 border border-purple-500/20">
                <div className="w-16 h-16 bg-gradient-to-r from-purple-400 to-pink-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-white mb-2">Performance Optimization</h4>
                <p className="text-gray-400">Expertise in optimizing applications for speed and efficiency</p>
              </div>
              
              <div className="text-center p-6 rounded-xl bg-gradient-to-br from-pink-500/10 to-blue-500/10 border border-pink-500/20">
                <div className="w-16 h-16 bg-gradient-to-r from-pink-400 to-blue-400 rounded-full flex items-center justify-center mx-auto mb-4">
                  <svg className="w-8 h-8 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h4 className="text-lg font-semibold text-white mb-2">Team Collaboration</h4>
                <p className="text-gray-400">Strong communication and collaboration skills in agile environments</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
